module.exports = __webpack_public_path__ + "static/media/icon_data-assign.54db2121.svg";